import React, { Component } from "react";

import "../../../../components/powerBI/components/report/style/style.css";
import { connect } from "react-redux";
import { setFullLoad, setRefresh } from "../../../../components/mdm/reducers/mdmReducer";
import { GlobalAgGrid } from "../../../../lib/globalAgGrid";
import "../../style.css";
import { EditableCellRenderer } from "../../../../components/agGrid/renderers";
import FKCellEditor from "./fkCellEditor";
import withRouter from "../../../../hocs/withRouter";

// cell renderer class
// function isObject(value) {
//   return value && typeof value === "object" && value.constructor === Object;
// }
// function FKKeyCreator(params) {
//   if (isObject(params.value) && params.value.name !== undefined) {
//     return params.value.name;
//   } else if (params.value !== undefined) {
//     return params.value;
//   } else {
//     return "";
//   }
// }
export function nullsLastComparator(a, b, _nodeA, _nodeB, isInverted) {
  const emptyA = isEmpty(a);
  const emptyB = isEmpty(b);

  // both empty – equal
  if (emptyA && emptyB) return 0;

  // A empty, B not empty  -> A must be after B
  if (emptyA) return isInverted ? -1 : 1; // flip for DESC

  // B empty, A not empty  -> B must be after A
  if (emptyB) return isInverted ? 1 : -1; // flip for DESC

  // neither empty – do normal comparison
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
}
function isObject(value) {
  return value && typeof value === "object" && value.constructor === Object;
}
function isEmpty(v) {
  return v === null || v === undefined || v === "";
}
function getComparableValue(val) {
  // Handle object with name property
  if (val && typeof val === "object" && val.name != null) {
    return val.name;
  }
  // Handle plain string/number
  if (typeof val === "string" || typeof val === "number") {
    return val;
  }
  return null;
}
function FKComparator(a, b, nodeA, nodeB, isInverted) {
  const nameA = getComparableValue(a);
  const nameB = getComparableValue(b);

  const emptyA = isEmpty(nameA);
  const emptyB = isEmpty(nameB);

  if (emptyA && emptyB) return 0;
  if (emptyA) return isInverted ? -1 : 1;
  if (emptyB) return isInverted ? 1 : -1;

  const strA = String(nameA).toLowerCase();
  const strB = String(nameB).toLowerCase();
  return strA.localeCompare(strB);
}
function getEditableCols(api) {
  try {
    return (api.getAllDisplayedColumns?.() ?? []).filter((col) => col.getColDef?.().editable === true);
  } catch (e) {
    return [];
  }
}
function FKCellRenderer() {}
FKCellRenderer.prototype.init = function (params) {
  this.eGui = document.createElement("div");
  if (params.colDef.editable) {
    this.eGui.className = "editable";
  }
  // Apply cellStyle from colDef if it exists
  if (params.colDef.cellStyle) {
    Object.assign(this.eGui.style, params.colDef.cellStyle);
  }
  var text = "";
  if (params.data && params.data[params.colDef.field] !== undefined && params.data[params.colDef.field] !== null) {
    if (params.data[params.colDef.field].name !== null && params.data[params.colDef.field].name !== undefined) {
      text = params.data[params.colDef.field].name;
      if (params.data[params.colDef.field].status === "invalid") {
        this.eGui.className = this.eGui.className + " paste-error ";
      }
    } else {
      text = params.data[params.colDef.field];
    }
  }
  if (typeof text === "object") {
    text = "";
  }
  this.eGui.textContent = text.toString();
};
FKCellRenderer.prototype.getGui = function () {
  return this.eGui;
};
function FKCellEditorRenderer() {}
FKCellEditorRenderer.prototype.init = function (params) {
  this.eGui = document.createElement("span");
  var text = "";
  if (params.value !== null && params.value !== undefined) {
    if (params.value.name !== null && params.value.name !== undefined) {
      text = params.value.name;
    }
  }

  this.eGui.textContent = text.toString();
};
FKCellEditorRenderer.prototype.getGui = function () {
  return this.eGui;
};

// ComboBoxEditor.prototype.getValue = function() {
//   if (this.eGui.name.includes("FK")) {
//     if (this.eGui.options[this.eGui.selectedIndex].value === "null") {
//       return {
//         id: null,
//         name: this.eGui.options[this.eGui.selectedIndex].text
//       };
//     } else {
//       return {
//         id: this.eGui.options[this.eGui.selectedIndex].value,
//         name: this.eGui.options[this.eGui.selectedIndex].text
//       };
//     }
//   } else {
//     if (this.eGui.options[this.eGui.selectedIndex].value === "null") {
//       return "";
//     } else {
//       return this.eGui.options[this.eGui.selectedIndex].value;
//       // return {
//       //   id: this.eGui.options[this.eGui.selectedIndex].value,
//       //   name: this.eGui.options[this.eGui.selectedIndex].text
//       // };
//     }
//   }
// };

function ComboBoxEditor() {}

ComboBoxEditor.prototype.init = function (params) {
  this.params = params;
  this.selectedValue = "";
  this._inputDebounceTimer = null;
  this._updateGeneration = 0;
  this.highlightedValue = null;
  this._highlightedIndex = -1;
  this._dropdownItems = [];

  if (params.value === undefined || params.value === null) {
    this.originalValue = null;
  } else {
    if (isObject(params.value)) {
      // Normalize undefined/null name to null to handle blank values from server
      this.originalValue = params.value.name ?? null;
    } else {
      this.originalValue = params.value;
    }
  }

  // Create the editor container
  this.eGui = document.createElement("div");
  this.eGui.setAttribute("class", "combo-box-editor");
  this.eGui.style.position = "relative";

  // Create an input field
  this.input = document.createElement("input");
  this.input.type = "text";
  this.input.setAttribute("class", "form-control");
  this.input.setAttribute("placeholder", "Type to search...");
  this.eGui.appendChild(this.input);
  this.eGui.setAttribute("name", params.colDef.field);

  // Create a dropdown container
  this.dropdown = document.createElement("ul");
  this.dropdown.setAttribute("name", params.colDef.field);
  this.dropdown.setAttribute("class", "dropdown-list");
  this.dropdown.style.position = "absolute";
  this.dropdown.style.top = "100%";
  this.dropdown.style.left = "0";
  this.dropdown.style.minWidth = "100%";
  this.dropdown.style.backgroundColor = "#fff";
  this.dropdown.style.border = "1px solid #ccc";
  this.dropdown.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.25)";
  this.dropdown.style.zIndex = "1000";
  this.dropdown.style.padding = "0";
  this.dropdown.style.margin = "0";
  this.dropdown.style.maxHeight = "200px";
  this.dropdown.style.overflowY = "auto";
  this.dropdown.style.display = "none"; // Initially hidden
  this.dropdown.style.paddingTop = "4px";
  this.eGui.appendChild(this.dropdown);

  if (this.originalValue && this.originalValue.name) {
    this.input.value = this.originalValue.name;
  } else if (typeof this.originalValue === "string") {
    this.input.value = this.originalValue;
  }

  // Filter values based on dependent column
  this.filteredValues = params.values;

  if (params.colDef.context?.picklistFilterColumn) {
    const dependentField = params.colDef.context.picklistFilterColumn;
    let dependentValue = params.data[dependentField] ? params.data[dependentField] : null;
    if (dependentValue && typeof dependentValue === "object" && dependentValue.name !== undefined) {
      dependentValue = dependentValue.name;
    }
    if (dependentValue) {
      this.filteredValues = params.values.filter((item) => item.dependent === dependentValue);
    } else {
      this.filteredValues = params.values; // No options if dependent value is not set
    }
  }

  this.handleFocus = () => {
    // Show dropdown on focus if there are fewer than 15000 items
    if (this.filteredValues && this.filteredValues.length < 15000) {
      this.updateDropdown("", this.filteredValues);
    }
  };

  this.handleInput = (event) => {
    const query = event.target.value.trim();
    clearTimeout(this._inputDebounceTimer);
    this._inputDebounceTimer = setTimeout(() => {
      if (!this.params || !this.eGui) return;
      if (query.length >= 1) {
        this.updateDropdown(query, this.filteredValues);
      } else if (this.filteredValues && this.filteredValues.length < 15000) {
        this.updateDropdown("", this.filteredValues);
      } else {
        this.dropdown.style.display = "none";
      }
    }, 200);
  };
  this.handleKeyDown = (e) => {
    // Skip if editor has been destroyed
    if (!this.params || !this.eGui) return;

    if (e.key === "Delete" && this.dropdown.style.display === "block") {
      e.stopPropagation();
      this.selectedValue = { id: null, name: "" };
      this.input.value = "";
      this.input.text = null;
      this.dropdown.style.display = "none";
      try {
        if (this.params?.api?.stopEditing) {
          this.params.api.stopEditing();
        }
      } catch (err) {
        //do nothing
      }
    } else if ((e.key === "ArrowDown" || e.key === "ArrowUp") && this.dropdown.style.display === "block") {
      e.preventDefault(); // prevent input cursor movement
      e.stopPropagation(); // prevent AG Grid from consuming arrow keys for row navigation
      const items = this.dropdown.querySelectorAll("li.dropdown-item");
      if (!items.length) return;
      const last = items.length - 1;
      let newIndex;
      if (e.key === "ArrowDown") {
        newIndex = this._highlightedIndex < last ? this._highlightedIndex + 1 : 0;
      } else {
        newIndex = this._highlightedIndex > 0 ? this._highlightedIndex - 1 : last;
      }
      this._applyHighlight(newIndex);
    } else if (e.key === "Enter" || e.key === "Tab") {
      // Resolve the best match into selectedValue so getValue() returns the right thing
      // when AG Grid calls it during its own stopEditing/navigation handling.
      // Do NOT call stopEditing() or stopPropagation() here — let AG Grid drive navigation.
      if (!this.selectedValue) {
        if (this.highlightedValue) {
          this.selectedValue = this.highlightedValue;
        } else {
          const typedText = this.input.value.trim().toLowerCase();
          const match = (this.filteredValues || []).find(
            (item) => item.name !== null && item.name !== undefined && String(item.name).toLowerCase() === typedText,
          );
          if (match) {
            this.selectedValue = match;
          }
          // If no match, leave selectedValue empty so getValue() returns originalValue
        }
      }
      this.dropdown.style.display = "none";
      // Let the event propagate — AG Grid handles Enter/Tab navigation
    }
  };

  // Close dropdown when clicking outside
  this.handleOutsideClick = (event) => {
    // Skip if editor has been destroyed
    if (!this.params || !this.eGui) return;

    if (!this.eGui.contains(event.target)) {
      const agRoot = event.target.closest?.(".ag-root-wrapper");
      this.dropdown.style.display = "none";
      // Only stop editing if the click is truly outside the grid (e.g. clicking
      // a browser UI element). If the click target is still inside the AG Grid
      // root the user is navigating within the table — let AG Grid handle it.
      if (!agRoot) {
        this.handleBlur();
      }
    }
  };

  document.addEventListener("click", this.handleOutsideClick);
  this.input.addEventListener("focus", this.handleFocus);
  this.input.addEventListener("input", this.handleInput);
  this.input.addEventListener("keydown", this.handleKeyDown);
};

ComboBoxEditor.prototype.getGui = function () {
  return this.eGui;
};

ComboBoxEditor.prototype.getValue = function () {
  if (!this.selectedValue) {
    // If the user typed text that differs from the original, try to resolve against picklist (handles Tab)
    const typedText = this.input?.value?.trim() ?? "";
    const originalDisplay =
      this.originalValue === null || this.originalValue === undefined
        ? ""
        : typeof this.originalValue === "string"
          ? this.originalValue
          : (this.originalValue?.name ?? "");

    if (typedText && typedText.toLowerCase() !== originalDisplay.toLowerCase()) {
      const match = (this.filteredValues || []).find(
        (item) => item.name !== null && item.name !== undefined && String(item.name).toLowerCase() === typedText.toLowerCase(),
      );
      if (match) {
        const isFk = this.params?.colDef?.field?.includes("FK");
        if (isFk) {
          return { id: match.id ?? null, name: match.name ?? "" };
        } else {
          return match.id === null || match.id === undefined ? (match.name ?? "") : match.id;
        }
      }
    }

    // For FK columns, return proper object format even when no change was made
    if (this.params?.colDef?.field?.includes("FK")) {
      // If originalValue is null/undefined, return blank FK object
      // Otherwise return the original value object from params
      if (this.originalValue === null || this.originalValue === undefined) {
        return { id: null, name: "" };
      } else {
        // Return the original params.value if it was an object
        return this.params.value;
      }
    }
    return this.originalValue;
  }

  if (isObject(this.selectedValue)) {
    // For FK columns, always return object format to maintain consistency
    if (this.params.colDef.field.includes("FK")) {
      return {
        id: this.selectedValue.id ?? null,
        name: this.selectedValue.name ?? "",
      };
    } else if (this.selectedValue.id === null || this.selectedValue.id === undefined) {
      return this.selectedValue.name ?? "";
    } else {
      return this.selectedValue.id;
    }
  }
  return this.selectedValue;
};

ComboBoxEditor.prototype.afterGuiAttached = function () {
  // In AG Grid v35, the key that triggered editing is exposed as `eventKey` (renamed from
  // `charPress` in older versions). Printable characters have event.key.length === 1.
  const char = this.params.eventKey;
  const isPrintable = char && char.length === 1;
  if (isPrintable) {
    // Set the value before focus() so it's visible immediately when the input is rendered.
    // handleFocus fires synchronously inside focus() and calls updateDropdown(""), but the
    // generation counter will discard that result once our updateDropdown(char) call below
    // increments the generation.
    this.input.value = char;
  }
  this.input.focus();
  if (isPrintable) {
    if (this.filteredValues && this.filteredValues.length < 15000) {
      this.updateDropdown(char, this.filteredValues);
    }
  } else {
    // Tab, Enter, F2, double-click — select existing text so typing immediately overwrites it.
    this.input.select();
  }
};

ComboBoxEditor.prototype._applyHighlight = function (index) {
  const items = this.dropdown.querySelectorAll("li.dropdown-item");
  // Remove highlight from previously highlighted item
  if (this._highlightedIndex >= 0 && this._highlightedIndex < items.length) {
    items[this._highlightedIndex].style.backgroundColor = "";
    items[this._highlightedIndex].style.fontWeight = "";
  }
  // Apply highlight to new item
  if (index >= 0 && index < items.length) {
    items[index].style.backgroundColor = "#e8f4fd";
    items[index].style.fontWeight = "bold";
    items[index].scrollIntoView({ block: "nearest" });
  }
  this.highlightedValue = this._dropdownItems[index] ?? null;
  this._highlightedIndex = index;
};

ComboBoxEditor.prototype.updateDropdown = async function (query, values) {
  // Capture generation so stale async results from previous keystrokes are discarded
  const generation = ++this._updateGeneration;

  const filteredValues = await this.fetchPicklistValues(query, values);

  // A newer call has already started — discard this result
  if (generation !== this._updateGeneration || !this.dropdown) return;

  const DROPDOWN_MAX_ITEMS = 100;
  const capped = filteredValues.length > DROPDOWN_MAX_ITEMS;
  const displayValues = capped ? filteredValues.slice(0, DROPDOWN_MAX_ITEMS) : filteredValues;
  this._dropdownItems = displayValues;

  // Determine best match to auto-highlight as user types
  const queryLower = query.toLowerCase();
  let bestMatch = null;
  if (queryLower) {
    // Prefer exact match, then starts-with
    bestMatch = displayValues.find(
      (item) => item.name !== null && item.name !== undefined && String(item.name).toLowerCase() === queryLower,
    );
    if (!bestMatch) {
      bestMatch = displayValues.find(
        (item) => item.name !== null && item.name !== undefined && String(item.name).toLowerCase().startsWith(queryLower),
      );
    }
  }
  this.highlightedValue = bestMatch || null;
  this._highlightedIndex = bestMatch ? displayValues.indexOf(bestMatch) : -1;

  // Build all nodes in a DocumentFragment to avoid repeated reflows
  const fragment = document.createDocumentFragment();

  displayValues.forEach((item) => {
    const listItem = document.createElement("li");

    listItem.textContent = item.name;
    listItem.setAttribute("data-value", item.id);
    if (item.id === null) {
      listItem.style.height = "24px";
    }
    listItem.style.padding = "8px";
    listItem.style.cursor = "pointer";
    listItem.style.listStyle = "none";

    listItem.classList.add("dropdown-item");
    if (item === bestMatch) {
      listItem.style.backgroundColor = "#e8f4fd";
      listItem.style.fontWeight = "bold";
    }

    // Highlight the selected item
    listItem.addEventListener("mousedown", (e) => {
      // Prevent the input from blurring when the user clicks a dropdown item.
      // Without this, the browser moves focus to body (since <li> is not
      // focusable), which can trigger stopEditingWhenGridLosesFocus before
      // our click handler runs, causing focus to leave the grid entirely.
      e.preventDefault();
    });
    listItem.addEventListener("click", () => {
      this.selectedValue = { id: item.id, name: item.name };
      this.input.value = item.name;
      this.input.text = item.id;
      this.dropdown.style.display = "none"; // Hide dropdown after selection
      // Notify the grid that editing is complete
      try {
        if (this.params?.api?.stopEditing) {
          const api = this.params.api;
          const focusedCell = api.getFocusedCell?.();
          api.stopEditing();
          // stopEditing removes the editor's <input> from the DOM, which moves
          // browser focus to body. Explicitly re-focus the cell so Tab/arrows
          // continue to navigate within the grid instead of the browser.
          if (focusedCell) {
            setTimeout(() => {
              try {
                api.setFocusedCell?.(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned);
              } catch (e) {}
            }, 0);
          }
        }
      } catch (err) {
        //do nothing
      }
    });

    fragment.appendChild(listItem);
  });

  if (capped) {
    const hint = document.createElement("li");
    hint.textContent = `Showing first ${DROPDOWN_MAX_ITEMS} of ${filteredValues.length} results — type more to narrow`;
    hint.style.padding = "6px 8px";
    hint.style.listStyle = "none";
    hint.style.color = "#888";
    hint.style.fontStyle = "italic";
    hint.style.fontSize = "11px";
    hint.style.cursor = "default";
    hint.style.borderTop = "1px solid #eee";
    fragment.appendChild(hint);
  }

  // Single DOM write: clear then append all at once
  this.dropdown.innerHTML = "";
  this.dropdown.appendChild(fragment);

  // Show the dropdown, flipping upward if there is insufficient space below
  if (filteredValues.length > 0) {
    this.dropdown.style.display = "block";
    const inputRect = this.input.getBoundingClientRect();
    const dropdownHeight = Math.min(200, this.dropdown.scrollHeight);
    const spaceBelow = window.innerHeight - inputRect.bottom;
    if (spaceBelow < dropdownHeight) {
      this.dropdown.style.top = "auto";
      this.dropdown.style.bottom = "100%";
    } else {
      this.dropdown.style.bottom = "auto";
      this.dropdown.style.top = "100%";
    }
  } else {
    this.dropdown.style.display = "none";
  }
};

// Simulate API or local filtering logic
ComboBoxEditor.prototype.fetchPicklistValues = async function (query, values) {
  // Replace this with your server API if needed
  const allValues = values;

  // Filter values based on the query
  return allValues.filter((item) => {
    if (item.name === null) {
      return 1;
    }
    return item.name.toLowerCase().includes(query.toLowerCase());
  });
};
ComboBoxEditor.prototype.handleBlur = function () {
  // Skip if editor has been destroyed
  if (!this.params) return;

  try {
    if (this.params.api !== undefined && this.params.api.stopEditing !== undefined) {
      this.params.api.stopEditing();
    }
  } catch (err) {
    //do nothing
  }
};

ComboBoxEditor.prototype.destroy = function () {
  clearTimeout(this._inputDebounceTimer);
  this._updateGeneration++; // Invalidate any in-flight updateDropdown calls
  document.removeEventListener("click", this.handleOutsideClick);
  this.input.removeEventListener("focus", this.handleFocus);
  this.input.removeEventListener("input", this.handleInput);
  this.input.removeEventListener("keydown", this.handleKeyDown);
  // Clear references to prevent stale handlers from interfering
  this.params = null;
  this.eGui = null;
  this.input = null;
  this.dropdown = null;
};

function checkboxCellRenderer(params) {
  if (params.colDef.editable) return `<input type='checkbox' ${params.value ? "checked" : ""} />`;
  else return `<input type='checkbox' disabled=true ${params.value ? "checked" : ""} />`;
}
function NonNullCellRenderer() {}
NonNullCellRenderer.prototype.init = function (params) {
  this.eGui = document.createElement("div");
  this.eGui.className = "editable";
  // Apply cellStyle from colDef if it exists
  if (params.colDef.cellStyle) {
    Object.assign(this.eGui.style, params.colDef.cellStyle);
  }
  var text = "";
  if (params.value !== null && params.value !== "" && params.value !== undefined) {
    if (params.value.name !== null) {
      text = params.value;
    }
  } else {
    this.eGui.className = "null editable";
  }
  this.eGui.textContent = text.toString();
};
NonNullCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

class DMGrid extends Component {
  constructor(props) {
    super(props);

    this.nrowsPerQuery = 5000;
    this.state = {
      update: false,
      params: null,
      processedColumns: this.processColumnDefs(props.currentTable),
    };
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      comparator: nullsLastComparator,
      suppressKeyboardEvent: (params) => {
        if (params.event.key !== "Enter") return false;
        const api = params.api;

        // Not editing: Enter on a ComboBoxEditor cell opens the editor instead of navigating down.
        if (!params.editing) {
          if (params.colDef.cellEditor === "ComboBoxEditor") {
            setTimeout(() => {
              try {
                api.startEditingCell({ rowIndex: params.node.rowIndex, colKey: params.column.getColId() });
              } catch (e) {}
            }, 0);
            return true; // suppress navigate-down
          }
          return false;
        }

        // Editing: intercept Enter on the last editable cell to jump to first editable of next row.
        const editableCols = getEditableCols(api);
        if (!editableCols.length) return false;
        const lastCol = editableCols[editableCols.length - 1];
        if (params.column.getColId() !== lastCol.getColId()) return false;
        const nextRowIndex = params.node.rowIndex + 1;
        const nextRow = api.getDisplayedRowAtIndex?.(nextRowIndex);
        if (!nextRow) {
          // Last row — add a new row and focus its first editable cell
          setTimeout(() => {
            try {
              api.stopEditing();
              if (this.props.onAddRowForKeyboard) {
                this.props.onAddRowForKeyboard(api, editableCols);
              }
            } catch (e) {}
          }, 0);
          return true; // suppress AG Grid's default behavior
        }
        setTimeout(() => {
          try {
            api.stopEditing();
            api.startEditingCell({ rowIndex: nextRowIndex, colKey: editableCols[0].getColId() });
          } catch (e) {}
        }, 0);
        return true; // suppress AG Grid's default Enter-moves-down
      },
    };

    // this.gridReady = this.gridReady.bind(this);
    this.agGrid = React.createRef();
    this.removeRows = this.removeRows.bind(this);
    // this.appendData = this.appendData.bind(this);
    // this.finishLoading = this.finishLoading.bind(this);
    this.isExternalFilterPresent = this.isExternalFilterPresent.bind(this);
    this.doesExternalFilterPass = this.doesExternalFilterPass.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // When AG Grid is actively editing a cell, suppress re-renders triggered by
    // external prop/store changes (e.g. a background data chunk arriving, or
    // DMGridContainer re-rendering with a new handleCellValueChanged reference).
    // Such re-renders propagate all the way down to CellComp and destroy the
    // freshly-opened editor before the user can interact with it.
    // Once editing ends (stopEditing is called), the next render catches up normally.
    if (this.gridApi) {
      try {
        const editing = this.gridApi.getEditingCells?.() ?? [];
        if (editing.length > 0) {
          // Always allow columnDef/table changes through (user switching tables)
          if (nextProps.currentTable !== this.props.currentTable) return true;
          // Otherwise suppress the re-render to protect the active editor
          return false;
        }
      } catch (e) {
        // gridApi may be destroyed; fall through to normal update
      }
    }
    return true;
  }

  processColumnDefs(currentTable) {
    if (currentTable === undefined || currentTable === null || currentTable.length === 0) {
      return [];
    }

    return currentTable.map((header) => {
      // Create a shallow copy to avoid mutating the original
      const { tableParameter, columnType, picklistFilterColumn, ...gridColumn } = header;
      const processedHeader = {
        ...gridColumn,
        // Server-provided colIds are numbers. AG Grid v36 only resolves columns by string id
        // (colModel.getCol), so a numeric colId breaks startEditing's cell lookup silently.
        ...(gridColumn.colId === undefined || gridColumn.colId === null ? {} : { colId: String(gridColumn.colId) }),
        context: {
          ...header.context,
          ...(tableParameter === undefined ? {} : { tableParameter }),
          ...(columnType === undefined ? {} : { columnType }),
          ...(picklistFilterColumn === undefined ? {} : { picklistFilterColumn }),
        },
      };

      if (processedHeader.cellRenderer === "FKCellRenderer") {
        // FK values are {id, name} objects. A cellRenderer does not stop AG Grid from inferring
        // cellDataType "object" (warning #48), so opt out of inference explicitly.
        processedHeader.cellDataType = false;
        // header.keyCreator = FKKeyCreator;
        processedHeader.filterValueGetter = function (params) {
          // console.log(params);

          const fValue = params.data[params.colDef.field];
          return fValue;
        };
        processedHeader.comparator = FKComparator;
        processedHeader.valueFormatter = (params) => {
          // debugger;
          if (
            params.colDef.cellEditorParams &&
            params.colDef.cellEditorParams.values.length > 2 &&
            params.colDef.cellEditorParams.values[1].dependent !== undefined
          ) {
            if (params.value === undefined || params.value === null) {
              return "";
            }

            return params.value.name || "";
          }
          // If params.value is {id, name}, show "name"
          if (params.value && typeof params.value === "object") {
            return params.value.name || "";
          }
          return params.value || "";
        };
        processedHeader.keyCreator = (params) => {
          // Needed for Set Filter to know uniqueness of object values
          if (params.value && typeof params.value === "object") {
            return params.value.name || "";
          }
          return params.value || "";
        };
        processedHeader.filterParams = {
          ...processedHeader.filterParams,
          keyCreator: processedHeader.keyCreator,
          valueFormatter: processedHeader.valueFormatter,
        };
      }

      if (processedHeader.cellEditor === "ComboBoxEditor") {
        // Values are {id, name} objects handled by our own valueSetter/editor. Disable AG Grid's
        // cellDataType inference, which would infer "object" and require a valueParser (warning #48).
        processedHeader.cellDataType = false;
        processedHeader.valueSetter = (params) => {
          const newVal = params.newValue;
          const field = params.colDef.field;
          const isFk = field.includes("FK");

          // Already correct object format (from ComboBoxEditor.getValue() or processCellFromClipboard)
          // Reject objects marked invalid by processCellFromClipboard
          if (newVal && typeof newVal === "object" && newVal.name !== undefined) {
            if (newVal.status === "invalid") {
              return false;
            }
            // Properly format for FK vs non-FK — don't blindly store the raw object
            const stored = isFk
              ? { id: newVal.id ?? null, name: newVal.name ?? "" }
              : newVal.id === null || newVal.id === undefined
                ? (newVal.name ?? "")
                : newVal.id;
            params.data[field] = stored;
            return true;
          }

          const values = params.colDef.cellEditorParams?.values || [];

          // Respect dependent-column filtering when resolving pasted/filled values
          let candidates = values;
          const filterCol = params.colDef.context?.picklistFilterColumn;
          if (filterCol) {
            let depVal = params.data[filterCol];
            if (depVal && typeof depVal === "object" && depVal.name !== undefined) {
              depVal = depVal.name;
            }
            if (depVal) {
              candidates = values.filter((item) => item.dependent === depVal);
            }
          }

          // Empty / clear
          if (newVal === null || newVal === undefined || String(newVal).trim() === "") {
            params.data[field] = isFk ? { id: null, name: "" } : "";
            return true;
          }

          const searchStr = String(newVal).trim().toLowerCase();

          // Primary: case-insensitive match by display name (handles clipboard paste)
          let match = candidates.find(
            (item) => item.name !== null && item.name !== undefined && String(item.name).toLowerCase() === searchStr,
          );

          // Fallback: match by stored id (handles fill-down where the cell holds an ID value)
          if (!match) {
            match = candidates.find(
              (item) => item.id !== null && item.id !== undefined && String(item.id) === String(newVal).trim(),
            );
          }

          if (match) {
            const stored = isFk
              ? { id: match.id ?? null, name: match.name ?? "" }
              : match.id === null || match.id === undefined
                ? (match.name ?? "")
                : match.id;
            params.data[field] = stored;
            return true;
          }

          // No matching picklist entry — leave the cell unchanged
          return false;
        };
      }

      return processedHeader;
    });
  }
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }
  componentDidUpdate(prevProps) {
    // Reprocess column definitions when currentTable changes
    if (this.props.currentTable !== prevProps.currentTable) {
      const processedColumns = this.processColumnDefs(this.props.currentTable);
      this.setState({ processedColumns });
    }

    if (this.props.externalFilterUpdate) {
      if (this.agGrid.current.gridApi !== undefined) {
        this.agGrid.current.gridApi.onFilterChanged();
      }
    }
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    clearInterval(this.timer);
    this.timer = null;
  }
  handleClickOutside = (event) => {
    if (this.agGrid.current && this.agGrid.current.gridApi) {
      const gridApi = this.agGrid.current.gridApi;

      // Example: Stop editing if clicking outside while editing
      if (!event.target.closest(".ag-root")) {
        gridApi.stopEditing();
      }
    }
  };
  onFilterChanged = async (params) => {
    const gridApi = params.api;
    // const columnApi = params.columnApi;
    // const gridRef = this.agGrid.current;
    const filterModel = gridApi.getFilterModel(); // Get current filters
    const filteredColumns = Object.keys(filterModel); // Columns currently filtered

    // Iterate through all column definitions to find dependencies
    if (this.state.processedColumns && Array.isArray(this.state.processedColumns)) {
      const filteredColumn = this.state.processedColumns[filteredColumns[0]];

      this.state.processedColumns.forEach(async (colDef) => {
        const dependentColumn = colDef;
        const parentColumn = colDef.context?.picklistFilterColumn;
        // if (parentColumn === "STATE") {
        //   console.log("DEPENDENT COLUMN");
        //   console.log(dependentColumn);
        //   console.log("PARENT COLUMN");
        //   console.log(parentColumn);
        //   console.log("FILTERED COLUMN");
        //   console.log(filteredColumn);
        // }
        // Check if the filtered column matches this column's picklistFilterColumn
        if (parentColumn && filteredColumn && filteredColumn.headerName === parentColumn) {
          // console.log("FILTER MODEL");
          // console.log(filterModel);
          const parentFilter = filterModel[filteredColumns[0]];
          // console.log("PARENT FILTER");
          // console.log(parentFilter);
          const filterValues = parentFilter.values; // Selected values in parent filter

          // Fetch updated LOV for the dependent column
          this.fetchUpdatedLOV(dependentColumn, filterValues)
            .then(async (updatedLOV) => {
              // console.log("FETCHED UPDATED LOV ");
              // console.log(updatedLOV);
              // console.log("UPDATING " + dependentColumn.headerName);
              gridApi.getColumnFilterInstance(dependentColumn.colId).then((filter) => {
                filter.refreshFilterValues();
              });
            })
            .catch((error) => {
              console.error(`Failed to update LOV for ${dependentColumn}:`, error);
            });
        } else if (colDef.context?.tableParameter) {
          this.props.filterDidChange(this.state.processedColumns[filteredColumns[0]], filterModel[filteredColumns[0]]);
        }
      });
    }
  };
  // Simulate API call to fetch updated LOV
  fetchUpdatedLOV = async (dependentColumn, filterValues) => {
    let returnLov = [];
    dependentColumn.cellEditorParams.values.forEach((item) => {
      if (filterValues.includes(item.dependend)) {
        returnLov.push(item.name);
      }
    });

    return returnLov;
  };
  cellValueChanged(item) {
    // console.log("Cell value changed:", {
    //   field: item.colDef.field,
    //   oldValue: item.oldValue,
    //   newValue: item.newValue,
    //   rowId: item.data.ID,
    // });
    //var start = new Date();

    if (item.data.crudType === undefined) {
      //console.log("in setting Crud Time");
      //var start1 = new Date();
      item.data.crudType = "update";
      //let endTime1 = new Date() - start1;
      //console.info("Execution time Crud: %dms", endTime1);
    }
    if (item.data.crudType === "empty") {
      item.data.crudType = "insert";
    }
    if (item.data.updated === undefined) {
      //console.log("in setting updated");
      //var start2 = new Date();
      if (isObject(item.newValue)) {
        item.data.updated = [
          {
            name: item.colDef.field,
            oldValue: item.oldValue || "",
            newValue: item.newValue,
          },
        ];
      } else {
        item.data.updated = [
          {
            name: item.colDef.field,
            oldValue: item.oldValue,
            newValue: item.newValue,
          },
        ];
      }
      //let endTime2 = new Date() - start2;
      //console.info("Execution time Setting updated: %dms", endTime2);
    } else {
      //console.log("in pushing updated");
      let pushedItems = item.data.updated.map((item) => {
        return item.name;
      });

      if (pushedItems.includes(item.colDef.field)) {
        item.data.updated = item.data.updated.map((updateItem) => {
          if (updateItem.name === item.colDef.field) {
            if (isObject(item.newValue)) {
              updateItem.newValue = item.newValue.name;
            } else {
              updateItem.newValue = item.newValue;
            }
          }
          return updateItem;
        });
      } else {
        item.data.updated.push({
          name: item.colDef.field,
          oldValue: item.oldvalue,
          newValue: item.newValue,
        });
      }
    }
    //var start3 = new Date();
    // setDirty(true) is a render-triggering side effect (see onCellValueChanged below
    // for why that has to stay deferred) — it's called from there, not here, so this
    // function is a plain, synchronous data mutation with no render side effects.

    //let endTime3 = new Date() - start3;
    //console.info("Execution time set State: %dms", endTime3);
    //console.log("END");
    //console.log(new Date());
    //let endTime = new Date() - start;
    //console.info("Execution time for Cell Value Changed: %dms", endTime);
    //  item.newOrModified = "Modified";
  }
  removeRows(selectedNodes) {
    this.props.removeRows(selectedNodes);
  }
  isExternalFilterPresent() {
    // if ageType is not everyone, then we are filtering
    //return ageType != "everyone";

    return this.props.externalFilter.length > 0;
  }

  doesExternalFilterPass(node) {
    const { externalFilter } = this.props;

    let retStatus = true;
    externalFilter.forEach((item) => {
      if (node.data[item.field] === false) {
        retStatus = false;
      }
    });
    return retStatus;
    //return node.data[externalFilter.field] === true;
  }
  render() {
    const { rowData, error, highlightedRowIds } = this.props;

    if (error !== null) {
      return <div>{error}</div>;
    }
    // console.log("THIS IS THE ROW DATA");
    // console.log(rowData);
    const highlightedIdSet = new Set((highlightedRowIds || []).map(String));
    return (
      <div style={{ height: "100%", paddingBottom: "10px" }}>
        <GlobalAgGrid
          // key={this.props.mdmConfig[this.state.activeIdx] ? this.props.mdmConfig[this.state.activeIdx].id : "default"}
          key={`${this.props.activeIdx}-${this.props.mdmConfig[this.props.activeIdx].id}`}
          ref={this.agGrid}
          defaultColDef={this.defaultColDef}
          onRowDataUpdated={(params) => {
            this.props.onRowDataReady(params.api);
            // params.api.autoSizeAllColumns({ skipHeader: false });
            // if (this.props.onRowDataUpdated) {
            //   this.props.onRowDataUpdated(params); // keep the callback you already forward
            // }
          }}
          onDuplicateRow={(newData, index) => {
            this.props.addNewRow({
              row: newData,
              index: index,
            });
          }}
          suppressScrollOnNewData={true}
          columnDefs={this.state.processedColumns}
          rowData={rowData}
          rowClassRules={{
            "mdm-save-failed-row": (params) => !!params.data && highlightedIdSet.has(String(params.data.ID)),
          }}
          enterNavigatesVerticallyAfterEdit={true}
          enterNavigatesVertically={true}
          tabToNextCell={(params) => {
            const api = params.api;
            const editableCols = getEditableCols(api);
            if (!editableCols.length) return params.nextCellPosition;
            const { backwards, previousCellPosition } = params;
            const currentColId = previousCellPosition.column.getColId();
            const currentIdx = editableCols.findIndex((c) => c.getColId() === currentColId);
            const rowIndex = previousCellPosition.rowIndex;
            if (!backwards) {
              // Tab forward
              if (currentIdx >= 0 && currentIdx < editableCols.length - 1) {
                // Move to next editable in same row
                return { rowIndex, column: editableCols[currentIdx + 1], rowPinned: previousCellPosition.rowPinned };
              }
              // Last editable (or focus was on non-editable) — move to first editable of next row
              const nextRow = api.getDisplayedRowAtIndex?.(rowIndex + 1);
              if (nextRow) {
                return { rowIndex: rowIndex + 1, column: editableCols[0], rowPinned: null };
              }
              // Last row — add a new row and focus its first editable cell.
              // Return previousCellPosition (stay in place) instead of null to avoid
              // AG Grid's NavigationService crashing when it tries to read rowIndex on null.
              if (this.props.onAddRowForKeyboard) {
                this.props.onAddRowForKeyboard(api, editableCols);
              }
              return previousCellPosition;
            } else {
              // Shift+Tab backward
              if (currentIdx > 0) {
                // Move to previous editable in same row
                return { rowIndex, column: editableCols[currentIdx - 1], rowPinned: previousCellPosition.rowPinned };
              }
              // First editable (or focus was on non-editable) — move to last editable of prev row
              const prevRow = rowIndex > 0 ? api.getDisplayedRowAtIndex?.(rowIndex - 1) : null;
              if (prevRow) {
                return { rowIndex: rowIndex - 1, column: editableCols[editableCols.length - 1], rowPinned: null };
              }
              return null; // no prev row — stay
            }
          }}
          onCellValueChanged={(item) => {
            // Commit crudType/updated onto the row SYNCHRONOUSLY, before anything else
            // runs. This used to be deferred via setTimeout(0) alongside the dirty-flag
            // dispatch below, which let a fast edit-then-Save beat this commit and read
            // the grid first: saveHandler's own guard (see saveHandler in
            // dataManagement/index.js) only flushes an editor that's still open when
            // Save is clicked, but Delete-clearing a cell never opens an editor at all —
            // onCellValueChanged fires synchronously with no editing state for that
            // guard to catch — so it couldn't help (BIG-1706/MDH-021 gap). cellValueChanged
            // is a plain object mutation with no render side effects (setDirty was moved
            // out of it, below), so there's no reason it needs to wait for the next task.
            this.cellValueChanged(item);

            // AG Grid creates the new editor (init/afterGuiAttached) BEFORE firing
            // onCellValueChanged for the old cell during Tab navigation, so
            // getEditingCells() returns [] here even though a new editor is active.
            // Defer the dirty-flag dispatch/re-render (and focus restoration) to the
            // next task so React re-renders triggered by setDirty(true) cannot destroy
            // a freshly-opened editor.
            setTimeout(() => {
              // Capture the currently-focused cell now (after AG Grid has
              // completed any enterNavigatesVertically movement), so we can
              // restore it after the re-render that follows the dispatch.
              const focusedCell = item.api?.getFocusedCell?.();
              const isEditing = (item.api?.getEditingCells?.() ?? []).length > 0;

              this.props.setDirty(true);
              if (this.props.onCellValueChanged) {
                this.props.onCellValueChanged(item);
              }

              // The dispatch above triggers a Redux update → React re-render →
              // AG Grid reconciles the changed row. Even with immutableData, this
              // can disrupt the focused cell's visual/keyboard state on the row
              // the user just navigated to. Restore focus after paint.
              if (focusedCell && !isEditing && item.api) {
                requestAnimationFrame(() => {
                  try {
                    if (!item.api.getEditingCells?.()?.length) {
                      item.api.setFocusedCell?.(focusedCell.rowIndex, focusedCell.column, focusedCell.rowPinned);
                    }
                  } catch (e) {}
                });
              }
            }, 0);
          }}
          //maxBlocksInCache={2}

          //rowModelType={"infinite"}
          //paginationAutoPageSize={true}
          //onCellEditingStopped={this.cellEditStopped}
          //onCellEditingStarted={this.cellEditStart}
          stopEditingWhenCellsLoseFocus={true}
          // getRowNodeId/immutableData/deltaRowDataMode were the pre-v29 names for this;
          // AG Grid v35 doesn't recognize any of them, so the grid had no row-identity
          // tracking at all and rebuilt every row from scratch on any rowData change
          // (visible as the whole grid flashing/re-animating on every save/refetch).
          // getRowId alone is enough in the current API — delta-update reconciliation
          // is automatic once it's provided.
          getRowId={(params) => String(params.data.ID)}
          onFilterChanged={this.onFilterChanged}
          components={{
            FKCellRenderer: FKCellRenderer,
            FKCellEditorRenderer: FKCellEditorRenderer,
            checkboxCellRenderer: checkboxCellRenderer,
            NonNullCellRenderer: NonNullCellRenderer,
            ComboBoxEditor: ComboBoxEditor,
            FKCellEditor: FKCellEditor,
            EditableCellRenderer: EditableCellRenderer,
          }}
          onModelUpdated={(params) => {
            // if (this.state.params !== null) {
            //   const allColumnIds = this.state.params.api.getColumns().map((col) => col.colId);
            //   this.state.params.api.autoSizeColumns({
            //     skipHeader: false,
            //     columns: allColumnIds,
            //   });
            // }
          }}
          //onBodyScroll={debounce(this.onScroll.bind(this), 100)}
          //getRowData={this.getRowData}
          removeRows={(selectedNodes) => {
            this.removeRows(selectedNodes);
          }}
          gridReady={(params) => {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            this.props.gridReady(this.agGrid);
          }}
          isExternalFilterPresent={this.isExternalFilterPresent}
          doesExternalFilterPass={this.doesExternalFilterPass}

          //getRowClass={getRowClass}
          //frameworkComponents={this.state.frameworkComponents}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mdmConfig: state.mdm.mdmConfig,
  loadedData: state.mdm.loadedData,
  loadingData: state.mdm.loadingData,
  loadedHydratedConfig: state.mdm.loadedHydratedConfig,
  loadingAppendData: state.mdm.loadingAppendData,
  nextRowToLoad: state.mdm.nextRowToLoad,
  rowCount: state.mdm.rowCount,
  error: state.mdm.error,
  data: state.mdm.data,
  refresh: state.mdm.refresh,
  lastId: state.mdm.lastId,
  externalFilter: state.mdm.externalFilter,
  externalFilterUpdate: state.mdm.externalFilterUpdate,
  fullLoad: state.mdm.fullLoad,
});
const mapDispatchToProps = (dispatch) => ({
  setFullLoad(status) {
    dispatch(setFullLoad(status));
  },
  setRefresh(status) {
    dispatch(setRefresh(status));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DMGrid));
